<template>
	<q-page padding>
		<div class="row q-mb-md">
			<div class="col-xs-12 col-sm-12">
				<div class="q-display-1 text-secondary">
					<q-icon name="fas fa-sign" class="q-mb-sm" /> {{ $t(title_trails) }}
				</div>
			</div>
		</div>

		<q-tabs v-model="tab">
			<q-tab slot="title" name="basic-data" :label="$t('basic_data')" />
			<q-tab
				slot="title"
				name="trainings"
				:label="$t(getLabel('title_trainings', 'trainings'))"
				v-show="showTab('trainings')"
			/>
			<q-tab
				slot="title"
				name="live-classes"
				:label="$t(getLabel('title_live_classes', 'live_classes'))"
				v-show="showTab('live_classes')"
			/>
			<q-tab
				slot="title"
				name="presentials"
				:label="$t(getLabel('title_presential', 'presential'))"
				v-show="showModule('presential')"
			/>
			<q-tab
				slot="title"
				name="webinars"
				:label="$t(getLabel('title_webcasts', 'webcasts'))"
				v-show="showTab('webcasts')"
			/>
			<q-tab
				slot="title"
				name="podcasts"
				:label="$t(getLabel('title_podcasts', 'podcasts'))"
				v-show="showTab('podcasts')"
			/>
			<q-tab
				slot="title"
				name="news"
				:label="$t(getLabel('title_news', 'news'))"
				v-show="showTab('news')"
			/>
			<q-tab
				slot="title"
				name="libraries"
				:label="$t(getLabel('title_library', 'library'))"
				v-show="showTab('library')"
			/>
			<q-tab
				slot="title"
				v-if="useCommentsTrail"
				name="comments"
				:label="$t('comments')"
				v-show="showTab('comments')"
			/>
			<q-tab
				slot="title"
				name="configure_and_publish"
				:label="$t('configure_and_publish')"
				v-show="showTab('configure_and_publish')"
			/>

			<q-tab-pane keep-alive name="basic-data">
				<basic-data :manage_trails="manageTrails" />
			</q-tab-pane>

			<q-tab-pane name="trainings">
				<trainings :manage_trails="manageTrails" />
			</q-tab-pane>

			<q-tab-pane name="presentials">
				<presentials :manage_trails="manageTrails" />
			</q-tab-pane>

			<q-tab-pane name="webinars">
				<webinars :manage_trails="manageTrails" />
			</q-tab-pane>

			<q-tab-pane name="live-classes">
				<live-classes :manage_trails="manageTrails" />
			</q-tab-pane>

			<q-tab-pane name="podcasts">
				<podcasts :manage_trails="manageTrails" />
			</q-tab-pane>

			<q-tab-pane name="libraries">
				<libraries :manage_trails="manageTrails" />
			</q-tab-pane>

			<q-tab-pane name="news">
				<news :manage_trails="manageTrails" />
			</q-tab-pane>

			<q-tab-pane name="comments">
				<comments origin="trails" :manager="manageTrails" />
			</q-tab-pane>

			<q-tab-pane name="configure_and_publish">
				<configure-and-publish @duplicate="changeTab" :manage_trails="manageTrails" />
			</q-tab-pane>
		</q-tabs>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import TabBasicData from 'components/admin/trails/TabBasicData'
import TabTrainings from 'components/admin/trails/TabTrainings'
import TabPresentials from 'components/admin/trails/TabPresentials'
import TabWebinars from 'components/admin/trails/TabWebinars'
import TabLiveClasses from 'components/admin/trails/TabLiveClasses'
import TabPodcasts from 'components/admin/trails/TabPodcasts'
import TabLibraries from 'components/admin/trails/TabLibraries'
import TabNews from 'components/admin/trails/TabNews'
import Comments from 'components/admin/Comments'
import TabConfigureAndPublish from 'components/admin/trails/TabConfigureAndPublish'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'trails', 'admin'] },

	data() {
		return {
			id_trail: '',
			tab: 'basic-data',
			selected_client: {},
		}
	},

	components: {
		'basic-data': TabBasicData,
		trainings: TabTrainings,
		presentials: TabPresentials,
		webinars: TabWebinars,
		'live-classes': TabLiveClasses,
		podcasts: TabPodcasts,
		libraries: TabLibraries,
		news: TabNews,
		comments: Comments,
		'configure-and-publish': TabConfigureAndPublish,
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			user_module_items: 'common/user_module_items',
			id_user_client_selected: 'common/id_user_client_selected',
			user_client_module_items: 'common/user_client_module_items',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		title_trails() {
			return this.selected_client.title_trails && this.selected_client.title_trails !== ''
				? this.selected_client.title_trails
				: 'trails'
		},

		useCommentsTrail() {
			let obj = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj) return obj.use_comments_trail
			else return true
		},

		manageTrails() {
			const client = this.user_client_module_items.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (client) {
				let obj = client.module_items.find((e) => e.slug === 'trails_manage')
				if (obj) return obj.permission
			}
			return false
		},
	},

	methods: {
		getLabel(key, alternative) {
			return this.selected_client[key] && this.selected_client[key] !== ''
				? this.selected_client[key]
				: alternative
		},

		showTab(tab) {
			if (this.id_trail != 0) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					if (tab === 'trainings') return obj.has_courses
					else if (tab === 'presential') return obj.has_presential
					else if (tab === 'webcasts') return obj.has_webcasts
					else if (tab === 'live_classes') return obj.has_live_classes
					else if (tab === 'podcasts') return obj.has_podcasts
					else if (tab === 'library') return obj.has_library
					else if (tab === 'news') return obj.has_news
					else return true
				}
			} else return false
		},

		showModule(tab) {
			if(tab === 'presential' && this.id_trail != 0) {
				let client = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				return client.presential_event_catalog
			}
			return false
        },

		changeTab() {
			this.tab = 'basic-data'
		},
	},

	watch: {
		$route: function(refreshPage) {
			this.id_trail = this.$route.params.id
		},
	},

	created() {
		this.id_trail = this.$route.params.id
		this.selected_client = this.clients.find((obj) => {
			return obj.id === this.id_user_client_selected
		})
	},
}
</script>

<style></style>
